import React from 'react';
import styled from 'styled-components';
import { Card } from 'react-bootstrap';
import PropTypes from 'prop-types';

const StyledCard = styled(Card)`
  background-color: #efefef;
  border-radius: 3px;
  box-shadow: none !important;
`;

const ExampleCard = ({ children }) => (
  <StyledCard className="mb-3">
    <Card.Body className="d-flex justify-content-center align-items-center">
      <>{children}</>
    </Card.Body>
  </StyledCard>
);

ExampleCard.propTypes = {
  children: PropTypes.node,
};

export default ExampleCard;
